// @ts-nocheck
import { useContext, useState } from 'react'
import { Draggable } from '@hello-pangea/dnd'
import cx from 'helpers/cx'

import PageEditorContext from 'js/page/PageEditor/PageEditorContext'
import PageWidget from 'js/page/Widget/Widget'

import styles from './Widget.module.css'
import WidgetActions from './WidgetActions'

/*
    Component is used in both page and group,
    so a lot of props are needed because context
    doesn't work or it needs different actions.
*/

const Widget = ({
    ref,
    id,
    index,
    entity,
    onEdit,
    onDelete,
    onAdd,
    onDuplicate,
    focusedWidget,
    setFocusedWidget,
    rowBackgroundColor,
    columnWidth,
}) => {
    const { site, group, isDragging, widgetEditing } =
        useContext(PageEditorContext)

    const [showWidgetPicker, setShowWidgetPicker] = useState(false)

    const { widgetGuid } = entity

    const isFocused = focusedWidget === widgetGuid

    const onFocus = () => {
        setFocusedWidget(widgetGuid)
    }

    const onBlur = () => {
        setFocusedWidget(false)
    }

    const isEditing =
        id ===
        `${widgetEditing?.rowIndex}-${widgetEditing?.columnIndex}-${widgetEditing?.index}`

    const isActive = isFocused || showWidgetPicker

    return (
        <Draggable
            draggableId={widgetGuid}
            index={index}
            isDragDisabled={!!widgetEditing}
        >
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className={cx(
                        styles.wrapper,
                        (snapshot.isDragging ||
                            isEditing ||
                            (isActive && !isDragging && !widgetEditing)) &&
                            styles.showOutline,
                        snapshot.isDragging && styles.showBackground,
                    )}
                    onMouseEnter={onFocus}
                    onMouseLeave={onBlur}
                >
                    <WidgetActions
                        show={
                            !widgetEditing &&
                            (snapshot.isDragging || (isActive && !isDragging))
                        }
                        id={id}
                        entity={entity}
                        snapshot={snapshot}
                        provided={provided}
                        widgetEditing={widgetEditing}
                        showWidgetPicker={showWidgetPicker}
                        setShowWidgetPicker={setShowWidgetPicker}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onAdd={onAdd}
                        onDuplicate={onDuplicate}
                        onFocus={onFocus}
                        onBlur={onBlur}
                    />

                    {isEditing ? (
                        <div ref={ref}>{/* Widget preview portal */}</div>
                    ) : (
                        <PageWidget
                            guid={widgetGuid}
                            site={site}
                            entity={entity}
                            editMode
                            rowBackgroundColor={rowBackgroundColor}
                            columnWidth={columnWidth}
                            group={group}
                            canEditContainer
                        />
                    )}
                </div>
            )}
        </Draggable>
    )
}

Widget.displayName = 'Widget'

export default Widget
